import { Form, Formik } from "formik";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import FormFooter from "../../../components/form-footer";
import { selectActiveFormWitnessDefendantStatementDetails, selectActiveFormWitnessDefendantStatementWitnessDetails, updateWitnessDefendantStatementWitnessDetails } from "../../../reducers/active-form-slice";
import WitnessDefendantStatementWitnessDetailsSchema from "../../../validation-schemas/witness-defendant-statement-witness-details";
import IntakeWitnessDefendantStatementWitnessDetailsFields from "../../../components/intake/witness-defendant-statement/witness-info-fields";
import FormHeaderButtons from '../form-header-buttons';
import { hasNonBlankValues } from '../../../utility/has-values';


const IntakeWitnessDefendantStatementWitnessInfo = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();


    /**
     * get current form values
     */
    const witnessDefendantStatementDetails = useSelector(selectActiveFormWitnessDefendantStatementDetails);
    const witnessDefendantStatementWitnessDetails = useSelector(selectActiveFormWitnessDefendantStatementWitnessDetails);
    const hasValues = hasNonBlankValues(witnessDefendantStatementWitnessDetails);


    /**
     * handle the previous button
     */
    const handlePrevious = () => {
        switch (witnessDefendantStatementDetails.statementType) {
            case "Both":
                navigate("/intake/witness-defendant-statement/defendant-info");
                break;
            default:
                navigate("/intake/witness-defendant-statement/details");
                break;
        }
    };


    /**
     * update active form & continue
     */
    const handleSubmit = (values) => {
        dispatch(updateWitnessDefendantStatementWitnessDetails(values));
        navigate("/intake/witness-defendant-statement/info");
    };

    /**
     * handle save for later
     */
    const handleSaveForLater = (values) => {
        dispatch(updateWitnessDefendantStatementWitnessDetails(values));
    };


    /**
     * setup the initial values
     */
    const witnessInitialValue = {
        firstName: '',
        lastName: '',
        phones: [],
        address1: '',
        address2: '',
        city: '',
        stateProvince: '',
        zip: '',
        county: '',
        interpreterInfo: '',
        isMinor: ''
    };

    const initialValues = {
        witnesses: [
            witnessInitialValue
        ],
    };


    return (
        <div className="page intake">
            <Formik
                initialValues={hasValues ? witnessDefendantStatementWitnessDetails : initialValues}
                validationSchema={WitnessDefendantStatementWitnessDetailsSchema.fields.witnessDefendantStatementWitnessDetails}
                onSubmit={handleSubmit}
            >
                {({ errors, dirty, isValid, touched, values }) => (
                    <Form>
                        <div className="form-header-buttons">
                            <div>
                                <h2>Witness OR Defendant Statement Details</h2>
                                <p>FILL WITH “N/A” IF NOT APPLICABLE ON REQUIRED FIELDS</p>
                            </div>
                            <FormHeaderButtons updateForm={() => handleSaveForLater(values)}/>
                        </div>
                
                        <IntakeWitnessDefendantStatementWitnessDetailsFields
                            errors={errors}
                            touched={touched}
                            values={values}
                            initialValues={witnessInitialValue}
                        />

                        <FormFooter
                            handlePrevious={handlePrevious}
                            showPrevious={true}
                            disableNext={!((dirty || hasValues) && isValid)}
                            showNext={true}
                            progress={`40`}
                        />
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default IntakeWitnessDefendantStatementWitnessInfo;